import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../assets/images/logo.svg';
import './Navbar.css';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <div className="navbar-logo-title" onClick={() => navigate('/') } style={{cursor:'pointer', display:'flex', alignItems:'center', gap:'0.5rem'}}>
        <img src={logo} alt="Logo" height={24} style={{height:24, width:'auto'}} />
        <span className="navbar-title">Chefbelle</span>
      </div>
      <div className="navbar-menu-group" style={{display:'flex', alignItems:'center', gap:'1.2rem'}}>
        <span className="navbar-link" onClick={() => navigate('/')}>Home</span>
        <span className="navbar-link" onClick={() => navigate('/about')}>About Us</span>
        <div className="navbar-menu" onClick={onMenuClick}>
          <MenuIcon style={{ fontSize: 24, color: '#fff' }} />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
